import strigns from "./strings.json";

const I18n = strigns;

export default I18n;
